import { Navigate, Route, Routes } from "react-router-dom";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import ApiDocumentation from "../components/ApiDocumentation";
import ApiKeys from "../components/ApiKeys";
import Billing from "../components/Billing";
import UsageHistory from "../components/UsageHistory";
import Analytics from "../components/Analytics";
import TeamManagement from "../components/TeamManagement";
import Settings from "../components/Settings";
import Support from "../components/Support";
import WhatsAppWidgetButton from "../components/WhatsAppWidgetButton";
import { DEFAULT_PROJECT_ID, businessPath } from "../config/businessMenu";

/** Admin shell. Home is All Projects. */
export default function AdminApp({ navOpen, onToggleNav, onCloseNav }) {
  return (
    <div className={`App admin-app${navOpen ? " admin-sidebar-open" : ""}`}>
      <Header onMenuToggle={onToggleNav} />
      <button
        type="button"
        className="admin-sidebar-overlay"
        aria-label="Close navigation menu"
        onClick={onCloseNav}
      />
      <div className="admin-layout">
        <Sidebar onNavClick={onCloseNav} />
        <main className="admin-content">
          <Routes>
            <Route path="/" element={<Navigate to="/all-projects" replace />} />
            <Route path="/dashboard" element={<Navigate to="/all-projects" replace />} />
            <Route
              path="/business-dashboard"
              element={
                <Navigate
                  to={businessPath(DEFAULT_PROJECT_ID, "dashboard")}
                  replace
                />
              }
            />
            <Route path="/docs" element={<ApiDocumentation />} />
            <Route path="/keys" element={<ApiKeys />} />
            <Route path="/billing" element={<Billing />} />
            <Route path="/history" element={<UsageHistory />} />
            <Route path="/analytics" element={<Analytics />} />
            <Route path="/team" element={<TeamManagement />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/support" element={<Support />} />
            <Route path="/whatsapp-widget-button" element={<WhatsAppWidgetButton />} />
            <Route path="*" element={<Navigate to="/all-projects" replace />} />
          </Routes>
        </main>
      </div>
    </div>
  );
}
